module.exports = __webpack_public_path__ + "98070cc66874d1e0bd722164f0f64ec9.jpg";